export const domDownload = (url, name) => {
  const link = document.createElement('a');
  const body = document.querySelector('body');
  link.href = url;
  link.setAttribute('download', name);

  link.style.display = 'none';
  body.appendChild(link);

  link.click();
  body.removeChild(link);
}